/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration Layer (BOL) API
 * Business Orchestration layer (BOL) API. Public part, exposed to BOL client applications.  Glossary | Definition -- | -- <strong>Logistics Object</strong> | A resource in the BOL system that represents a business entity, such as a QuotationRequest, Quotation, or Service. Logistics Objects are managed through the BOL API and can be accessed or modified by Users based on their permissions i.e. based on their AD Entra ID roles and ACL (Access Control List) modes. <strong>Member</strong> | A data owner in the BOL system, uniquely identified by its `memberIdentifier`. Members are used to manage access control and ownership of Logistics Objects. <strong>User</strong> | A person or entity that interacts with the BOL system, typically through a client application, and beeing authenticated. Users are associated with Members and can perform actions on Logistics Objects based on their access level. User access token includes the Member identifier as part of roles claims. Each path in the API is protected by a custom role defined in AD Entra ID, and operations on Logistics Objects are protected by specific Access modes defined by members. <strong>Access Control</strong> | The mechanism by which the BOL system restricts access to API paths and resources based on the identity of the User and their associated Member. Access control is enforced through AD Entra ID roles and ACL (Access Control List) modes defined for every single Logistics Object. <strong>ACL (Access Control List)</strong> | A set of authorizations that define what actions a User can perform on a Logistics Object. The level of access granted to Users is determined by ACL modes defined in authorizations for specific Logistics Objects. ACL Modes are not directly associated with Users but rather with Members, which are the data owners of Logistics Objects. Each Logistics Object has an ACL that specifies the access modes for different Members. Members need to exist in the BOL system to be granted access to Logistics Objects. <strong>ACL Mode</strong> | The specific level of access control applied to a Logistics Object, determining what actions can be performed by Users. ACL modes are defined for each Logistics Object by `memberIdentifier` and include `READ`, `WRITE`, and `CONTROL`. Each mode includes access granted by the modes under it, so `CONTROL` includes `WRITE` and `READ`, and `WRITE` includes `READ`. <strong>Change Request</strong> | A request to modify a Logistics Object, which is processed by the BOL system. Change requests are created when a User wants to update an existing Logistics Object, and they are subject to approval and application by the system. All changes to Logistics Objects are done through change requests. This allows for a controlled and auditable process of modifications. <strong>Host</strong> | A server alias in the BOL system, used to abstract URI values internally. This allows for flexibility in the underlying infrastructure when migrating or changing server configurations. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Value } from './Value';
import {
    ValueFromJSON,
    ValueFromJSONTyped,
    ValueToJSON,
    ValueToJSONTyped,
} from './Value';

/**
 * A special characteristic is used on an object to give non standard information about it. By default, special characteristics are defined between the parties involved in the logistic chain. Some industries can define a list of characteristics specific to their industry. Special characteristics can be applied on all logistics Objects
 * @export
 * @interface SpecialCharacteristic
 */
export interface SpecialCharacteristic {
    /**
     * Special characteristic string value if applicable.
     * @type {string}
     * @memberof SpecialCharacteristic
     */
    stringValue?: string;
    /**
     * ID of a special characteristics of the object agreed between the customer and the provider. A list of characteristics can be defined and normalized by an industry.
     * @type {string}
     * @memberof SpecialCharacteristic
     */
    characteristicReference?: string;
    /**
     * Type of special characteristic. The list is defined by the representation of a business market or an agreement between customer and supplier.
     * @type {string}
     * @memberof SpecialCharacteristic
     */
    specialCharacteristicType?: string;
    /**
     * Special characteristic numerical value if applicable.
     * @type {Value}
     * @memberof SpecialCharacteristic
     */
    numericalValue?: Value;
}

/**
 * Check if a given object implements the SpecialCharacteristic interface.
 */
export function instanceOfSpecialCharacteristic(value: object): value is SpecialCharacteristic {
    return true;
}

export function SpecialCharacteristicFromJSON(json: any): SpecialCharacteristic {
    return SpecialCharacteristicFromJSONTyped(json, false);
}

export function SpecialCharacteristicFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpecialCharacteristic {
    if (json == null) {
        return json;
    }
    return {
        
        'stringValue': json['stringValue'] == null ? undefined : json['stringValue'],
        'characteristicReference': json['characteristicReference'] == null ? undefined : json['characteristicReference'],
        'specialCharacteristicType': json['specialCharacteristicType'] == null ? undefined : json['specialCharacteristicType'],
        'numericalValue': json['numericalValue'] == null ? undefined : ValueFromJSON(json['numericalValue']),
    };
}

export function SpecialCharacteristicToJSON(json: any): SpecialCharacteristic {
    return SpecialCharacteristicToJSONTyped(json, false);
}

export function SpecialCharacteristicToJSONTyped(value?: SpecialCharacteristic | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'stringValue': value['stringValue'],
        'characteristicReference': value['characteristicReference'],
        'specialCharacteristicType': value['specialCharacteristicType'],
        'numericalValue': ValueToJSON(value['numericalValue']),
    };
}

